module.exports = __webpack_public_path__ + "img/deal-one.7b1bef7f.jpg";